import { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { getStudyStage } from "utils/api";
import { useAppConfig } from "context/ConfigContext";
import { useNavigate } from "react-router-dom";

const DEFAULT_STATE_USER = {
  isLoggedIn: null,
  role: null,
  randomization: null,
  username: null,
  email: null,
};

export const UserContext = createContext(null);

const UserProvider = ({ children }) => {
  const appConfig = useAppConfig();
  const [user, setUser] = useState(DEFAULT_STATE_USER);
  const [subjectStage, setSubjectStage] = useState("LOGGED_OUT");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    //Sync methods
    setLoading(true);
    loadUserInfo();
    setLoading(false);
  }, []);

  const loadUserInfo = () => {
    const token = localStorage.getItem("idToken");

    if (token != null) {
      const decodedIdToken = jwtDecode(token);
      var role, randomization;
      if (Array.isArray(decodedIdToken["cognito:groups"])) {
        role = decodedIdToken["cognito:groups"].includes("researcher")
          ? "researcher"
          : "subject";
        if (decodedIdToken["cognito:groups"].includes("edu"))
          randomization = "EDU";
        else if (decodedIdToken["cognito:groups"].includes("hrvb"))
          randomization = "HRVB";
      }

      const email = decodedIdToken["email"];
      const username = decodedIdToken["cognito:username"];
      setUser({
        ...user,
        isLoggedIn: true,
        role: role || "subject",
        randomization: randomization,
        username: username || "unknown",
        email: email || "unknown",
      });

      if (
        role === "researcher" &&
        !window.location.pathname.includes("/dashboard/researcher")
      )
        navigate("/dashboard/researcher");
      if (
        role === "subject" &&
        !window.location.pathname.includes("/dashboard/subject")
      )
        navigate("/dashboard/subject");
    } else {
      setUser({
        ...user,
        isLoggedIn: false,
      });
    }
  };

  const login = ({ tokens, refresh = true }) => {
    if (!user.isLoggedIn || refresh === true) {
      updateTokens(tokens);
      loadUserInfo();
    }
  };

  const updateTokens = (tokens) => {
    localStorage.setItem("accessToken", tokens["access_token"]);
    localStorage.setItem("idToken", tokens["id_token"]);
    if (tokens["refresh_token"])
      localStorage.setItem("refreshToken", tokens["refresh_token"]);
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("idToken");
    localStorage.removeItem("refreshToken");
    window.location.href = appConfig.COGNITO_HOSTED_UI_LOGOUT;
  };

  return (
    <UserContext.Provider
      value={{
        user,
        login,
        logout,
        updateTokens,
        setSubjectStage,
        subjectStage,
        loading,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserProvider;
